import React from "react";

export const PageHeader = ({ eyebrow, title, subtitle, accentImg }) => (
  <section className="relative pt-36 pb-20 md:pt-44 md:pb-28 overflow-hidden bg-gradient-to-b from-brand-green-50 to-white">
    <div className="absolute inset-0 grain pointer-events-none opacity-30" />
    <div className="absolute -top-20 -right-32 w-[28rem] h-[28rem] rounded-full bg-brand-green/10 blur-3xl float-slow pointer-events-none" />
    <div className="absolute top-40 -left-24 w-72 h-72 rounded-full bg-brand-gold/15 blur-3xl float-medium pointer-events-none" />

    <div className="relative max-w-7xl mx-auto px-6 md:px-10">
      <div className="max-w-4xl">
        {eyebrow && (
          <div className="text-xs font-bold tracking-[0.25em] uppercase text-brand-gold mb-6">{eyebrow}</div>
        )}
        <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl leading-[0.98] tracking-tight text-brand-ink fade-up">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-8 text-lg md:text-xl text-brand-slate max-w-2xl leading-relaxed fade-up" style={{ animationDelay: "0.1s" }}>
            {subtitle}
          </p>
        )}
      </div>
    </div>
  </section>
);

export default PageHeader;
